import type { SeatEnforcement } from "../api/types";
import { sydneyStamp } from "./format";

function since(e: SeatEnforcement): string {
  if (e.at === null) return "";
  const stamp = sydneyStamp(e.at);
  return ` (since ${stamp}${e.by === null ? "" : `, by ${e.by}`})`;
}

/** Spec §9: the page says out loud when seat enforcement is off, because a
 *  silent page and a working cap look identical from here. */
export function EnforcementNotice({
  enforcement,
}: {
  enforcement: SeatEnforcement;
}): JSX.Element | null {
  const box = {
    background: "#fff3cd",
    color: "#5c4500",
    padding: "0.5rem 1rem",
    fontSize: 14,
    marginBottom: 12,
  };
  if (!enforcement.readable) {
    return (
      <div role="alert" style={box}>
        The seat enforcement flag can't be read, so caps and one-device are both off. Run{" "}
        <code>video-map seats on</code> to fix it.
      </div>
    );
  }
  if (enforcement.caps && enforcement.oneDevice) return null;
  return (
    <div role="note" style={box}>
      {!enforcement.caps && <div>Seat caps are off{since(enforcement)}.</div>}
      {!enforcement.oneDevice && <div>One device per name is off{since(enforcement)}.</div>}
    </div>
  );
}
